import type {ComponentProps, FC} from 'react';

import React, {forwardRef} from 'react';
// @ts-expect-error
import {browserHistory} from '@pb/kit-history';


type NativeLinkProps = ComponentProps<'a'>;
export interface LinkProps extends NativeLinkProps {
    /**
     * Custom HTML tag
     */
    customTag?: string,
}

/**
 * @component
 * @name Link
 * @description For UI Kit internal usage only
 * @param {LinkProps} props
 * @deprecated It will be removed in 6 months 09-20-2025. use onClick of any other component instead
 * */
export const Link = forwardRef((props: LinkProps, ref) => {
    const {
        children,
        href,
        customTag,
        onClick,
        target = null,
        role,
        ...restProps
    } = props;

    const onClickHandler: LinkProps['onClick'] = e => {
        if (e.metaKey || e.ctrlKey) {
            if (onClick) {
                onClick(e);
            }
            return;
        }

        e.preventDefault();

        if (href) {
            if (!target) {
                browserHistory.push(href);
            } else {
                window.open(href, target);
            }
        }

        if (onClick) {
            onClick(e);
        }
    };

    const Slug = customTag ?? 'a';
    return (
        <Slug
            {...{
                href,
                target,
                role: role ?? (customTag ? 'link' : undefined),
                onClick: onClickHandler,
                ...restProps,
                ref,
            }}>
            {children}
        </Slug>
    );
}) as FC<LinkProps>;

Link.displayName = 'Link';
